export default __webpack_public_path__ + "static/media/icon-palette.bc3de03b.svg";